import React from "react";
import { MsalAuthenticationResult } from "@azure/msal-react";


export const AuthError = (props: MsalAuthenticationResult): JSX.Element => {
	return (
		<p>{props?.error}</p>
	);
};
